type StorageKind = 'session' | 'local'

// Accessing `window.sessionStorage` / `window.localStorage` — even reading the
// property — throws a SecurityError when storage is blocked (cookies disabled,
// sandboxed iframe, some in-app browsers). Optional chaining does NOT help, since
// the throw happens on the property read itself. Always go through these helpers.
const getStore = (kind: StorageKind): Storage | null => {
  try {
    return kind === 'session' ? window.sessionStorage : window.localStorage
  } catch {
    return null
  }
}

export const safeStorageGet = (key: string, kind: StorageKind = 'session'): string | null => {
  try {
    return getStore(kind)?.getItem(key) ?? null
  } catch {
    return null
  }
}

export const safeStorageSet = (key: string, value: string, kind: StorageKind = 'session'): void => {
  try {
    getStore(kind)?.setItem(key, value)
  } catch {
    // storage unavailable (private mode, blocked cookies, sandboxed iframe)
  }
}

export const safeStorageRemove = (key: string, kind: StorageKind = 'session'): void => {
  try {
    getStore(kind)?.removeItem(key)
  } catch {
    // storage unavailable
  }
}
